import React from 'react';

import KaartNl from '@/assets/icons/KaartNl';
import KnoopGebiedCard from '@/components/bakkenteller/knoopGebied/KnoopGebiedCard';
import MapDot from '@/components/bakkenteller/mapDot/Mapdot';
import Timeline from '@/components/bakkenteller/timeline/Timeline';
import MwdDialog from '@/components/UI/Dialog/Dialog';

import useBakkenteller from './useBakkenteller';

import styles from './bakkenteller.module.css';
import dialogStyles from '@/components/UI/Dialog/Dialog.module.css';

type BakkentellerProps = {
  showBakkenteller: boolean;
  handleOpenChange: () => void;
};

export default function Bakkenteller({ showBakkenteller, handleOpenChange }: BakkentellerProps) {
  const { mapDotData, selectedLabel, cardData, handleDotClick, getDotColor } = useBakkenteller();

  return (
    <>
      <MwdDialog
        className={dialogStyles.bakkentellerDialogStyle}
        title='Bakkenteller'
        showDialog={showBakkenteller}
        handleOpenChange={handleOpenChange}
        hasCloseInHeader
      >
        <div className={styles.bakkentellerContainer}>
          <div className={styles.mapWrapper}>
            <KaartNl className={styles.kaartNl} />
            {mapDotData.map(({ label, value, top, left, maxCapacity }) => {
              const percentage = (value / maxCapacity) * 100;
              return (
                <MapDot
                  key={label}
                  color={getDotColor(percentage)}
                  top={top}
                  left={left}
                  label={label}
                  selected={selectedLabel === label}
                  onClick={() => handleDotClick(label)}
                >
                  {value}
                </MapDot>
              );
            })}
          </div>
          <KnoopGebiedCard title={cardData?.title} subtitle={cardData?.subtitle} list={cardData?.list} />
        </div>
        <Timeline />
      </MwdDialog>
    </>
  );
}
